import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Icon } from '../Icon';
import styles from './NoData.css';

const cx = classnames.bind(styles);

function NoData({
    title,
    children,
    className
}) {
    const classes = cx({
        root: true,
        [className]: className
    });

    return (
        <div className={classes}>
            <Icon name='cards' className={styles.icon} />
            <p className={styles.title}>{title}</p>
            {children}
        </div>
    );
}

NoData.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.any,
    className: PropTypes.string
};

NoData.defaultProps = {
    className: ''
};

export {
    NoData
};
